export default __webpack_public_path__ + "static/creatoreconomy-29b7ab9272a035d8dadd630c94d54dd6.jpg";